module.exports = __webpack_public_path__ + "img/payname2.dfd8b581.png";